// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"6fd61e19","160":"cb27fa0a","208":"79f82ed8","227":"12fb293d","293":"4b61c37c","516":"61c462f8","519":"502cfcf7","917":"14e8f6ee","946":"f8fb0b18"}[chunkId] + ".chunk.js";
};